import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropdownItem } from '../../app/app.interfaces';

@Component({
  selector: 'dropdown',
  templateUrl: 'dropdown.html'
})
export class Dropdown {
  
  @Input()
  public items: DropdownItem[] = [];
  
  @Input()
  public placeholder: string = '';
  
  @Output()
  public onSearchTermChange: EventEmitter<string> = new EventEmitter();
  
  @Output()
  public onItemSelection: EventEmitter<DropdownItem> = new EventEmitter();
  
  public searchTerm: string = '';
  public showDropdownMenu: boolean = false;
  private canToggle: boolean = true;
  private toggleCooldownMs: number = 250; // TODO: Needs refactoring, cooldown used to prevent multiple calls to toggleSendersDropdown()
  
  constructor() {
  }

  toggleDropdown(show: boolean = null) {
    if (this.canToggle) {
      if(show!==null) this.showDropdownMenu = show;
      else this.showDropdownMenu=!this.showDropdownMenu;
      this.canToggle = false;
      setTimeout(() => this.canToggle = true, this.toggleCooldownMs);
    }
  }
  
  searchTermChanged(event) {
    this.onSearchTermChange.emit(this.searchTerm);
  }
  
  handleItemSelection(item: DropdownItem) {
    this.searchTerm = item.title;
    this.onItemSelection.emit(item);
  }
}



// WEBPACK FOOTER //
// ./src/partials/dropdown/dropdown.ts